import React, { useState } from 'react'
import ClaimYourSpot from './coach/webinar/claim-your-spot';

const WebinarData = ({ templateData, state }) => {
    const [isSpotModal, setIsSpotModal] = useState(false);
    const [isSuccessModal, setIsSuccessModal] = useState(true);
    const [id, setId] = useState("");

    return (
      <>
        <section
          class="ct_workshop_banner_detail ct_px_40 mt-5"
          style={{
            background: "linear-gradient(135deg, #bfc7cb 0%, #bde4f6 100%)",
          }}
        >
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-5 mb-4 mb-lg-0">
                <div class="ct_workshop_right_img">
                  <img
                    src="/assets/img/work_detail_banner_left.png"
                    alt=""
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
              <div class="col-lg-7 mb-4 mb-lg-0">
                <div class="ps-lg-5">
                  <h2 class="ct_fs_50 mb-3" style={{ maxWidth: "596px" }}>
                    {templateData?.section1?.heading ?? ""}
                  </h2>
                  <p class="mb-0 ct_fs_20" style={{ maxWidth: "565px" }}>
                    {templateData?.section1?.body ?? ""}
                  </p>
                  <div class="mt-4">
                    <a
                      class="ct_yellow_btn px-5 ct_fit_content ct_orange_bg"
                      onClick={() => {
                        setIsSpotModal(true);
                        setId(templateData?.webinar_id);
                      }}
                    >
                      Reserve Your Spot
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="ct_py_100 ct_px_100">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <h2 class="ct_fs_40 ct_darksky_blue_text text-center mb-3 ct_fw_600">
                  {templateData?.section2?.heading ?? ""}
                </h2>
                <p
                  class="mb-0 ct_fs_24 text-center mx-auto"
                  style={{ maxWidth: "684px" }}
                >
                  {templateData?.section2?.body ?? ""}
                </p>
              </div>
            </div>
            <div class="row mt-5 pt-3">
              <div class="col-lg-4 mb-4 mb-lg-0">
                <div
                  class="ct_what_learn_card mb-4"
                  style={{ backgroundColor: "#F7F7F7" }}
                >
                  <div>
                    <h4 class="ct_fs_24 mb-2">
                      {templateData?.section2?.subHeading1}
                    </h4>
                    <p class="mb-0 ct_grey_text">
                      {templateData?.section2?.subBody1}
                    </p>
                  </div>
                  <div class="ct_mt_20  d-flex justify-content-end">
                    <a class="ct_top_right_arrow_icon">
                      <img src="/assets/img/right_top_arrow.svg" alt="" />
                    </a>
                  </div>
                </div>
                <div
                  class="ct_what_learn_card mb-4"
                  style={{ backgroundColor: "#EDF6F9" }}
                >
                  <div>
                    <h4 class="ct_fs_24 mb-2">
                      {templateData?.section2?.subHeading3}
                    </h4>
                    <p class="mb-0 ct_grey_text">
                      {templateData?.section2?.subBody3}
                    </p>
                  </div>
                  <div class="ct_mt_20  d-flex justify-content-end">
                    <a class="ct_top_right_arrow_icon">
                      <img src="/assets/img/right_top_arrow.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 mb-4 mb-lg-0">
                <label class="ct_learn_img">
                  <img src="/assets/img/you_will_learn_img.png" alt="" />
                </label>
              </div>
              <div class="col-lg-4 mb-4 mb-lg-0">
                <div
                  class="ct_what_learn_card mb-4"
                  style={{ backgroundColor: "#ffb80526" }}
                >
                  <div>
                    <h4 class="ct_fs_24 mb-2">
                      {templateData?.section2?.subHeading2}
                    </h4>
                    <p class="mb-0 ct_grey_text">
                      {templateData?.section2?.subBody2}
                    </p>
                  </div>
                  <div class="ct_mt_20  d-flex justify-content-end">
                    <a class="ct_top_right_arrow_icon">
                      <img src="/assets/img/right_top_arrow.svg" alt="" />
                    </a>
                  </div>
                </div>
                <div
                  class="ct_what_learn_card mb-4"
                  style={{ backgroundColor: "#F5F3EF" }}
                >
                  <div>
                    <h4 class="ct_fs_24 mb-2">
                      {templateData?.section2?.subHeading4}
                    </h4>
                    <p class="mb-0 ct_grey_text">
                      {templateData?.section2?.subBody4}
                    </p>
                  </div>
                  <div class="ct_mt_20  d-flex justify-content-end">
                    <a class="ct_top_right_arrow_icon">
                      <img src="/assets/img/right_top_arrow.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {state?.data?.speakers?.length != 0 &&
        state?.data?.speakers?.length == 1 ? (
          <section
            class="ct_coach_created_bg mt-0 ct_py_100"
            style={{ backgroundColor: "#ffb80533" }}
          >
            <div class="container">
              <div class="row">
                <div class="col-lg-4  mb-4 mb-lg-0">
                  <label class="ct_learn_img d-block">
                    <img
                      src={
                        state?.data?.speakers[0]?.image ??
                        "/assets/img/meet_nellie_img.png"
                      }
                      alt=""
                      style={{ height: "400px" }}
                    />
                  </label>
                </div>
                <div class="col-lg-8 mb-4 mb-lg-0 ps-lg-5">
                  <div class="d-flex align-items-end gap-3 ct_flex_col_575">
                    <div>
                      <h4 class="ct_fs_28 ct_orange_text mb-4">
                        {state?.data?.speakers[0]?.name ?? ""}
                      </h4>
                      <p class="ct_fs_22 mb-0">
                        {state?.data?.speakers[0]?.role ?? ""}
                      </p>
                      <div class="mt-4">
                        <p class="ct_fs_20 mb-3" style={{ maxWidth: "545px" }}>
                          {state?.data?.speakers[0]?.sub_role ?? ""}
                        </p>
                      </div>
                      <div class="mt-5">
                        <a class="ct_yellow_btn ct_orange_bg ct_fit_content px-5 mx-auto">
                          View My Profile
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section class=" mt-0 ct_py_100">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h2 class="ct_darksky_blue_text text-center ct_fs_44 ct_fw_600 pb-5">
                    Speakers
                  </h2>
                </div>
              </div>
              <div class="row ct_px_40 justify-content-between">
                {state?.data?.speakers?.map((item, i) => (
                  <div class="col-xl-3 col-lg-3 mb-4 ">
                    <div className="position-relative">
                      <div class="ct_speakers_card">
                        <label class="ct_speaker_img d-block mx-auto">
                          <img
                            src={
                              item?.image ?? "/assets/img/meet_nellie_img.png"
                            }
                            alt=""
                          />
                        </label>
                        <div class="ct_about_speaker text-center">
                          <h4
                            class="ct_fs_32 ct_fw_600 mb-2 ct_blue_text"
                            contentEditable="true"
                          >
                            {item?.name ?? ""}
                          </h4>
                          <p class="ct_fs_16" contentEditable="true">
                            {item?.role ?? ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
        <section
          class="ct_looking_for_work_bg ct_mt_100  ct_p_111_y_106 ct_looking_for_work_bg_left"
          style={{ backgroundColor: "#F58220" }}
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-4">
                Built For Founders. Backed by Experience
              </h4>
              <p class="mb-0 ct_fs_18">
                We’ve designed this workshop to deliver clear direction, not
                just inspiration.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a
                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                onClick={() => {
                  setIsSpotModal(true);
                  setId(templateData?.webinar_id);
                }}
              >
                Reserve Your Spot
              </a>
            </div>
          </div>
        </section>
        <section class="ct_pt_100 ct_pb_100 ct_px_40">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-3 mb-4 mb-lg-0">
                <label class="ct_how_work_img">
                  <img src="/assets/img/how_work_678.png" alt="" />
                </label>
              </div>
              <div class="col-lg-9 mb-4 mb-lg-0 ps-lg-5">
                <div class="ct_how_work_content pb-3">
                  <h4 class="ct_fs_24 ct_yellow_text">
                    {templateData?.section4?.heading ?? ""}
                  </h4>
                  <h3 class="ct_fs_32">
                    {templateData?.section4?.title ?? ""}
                  </h3>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-4">
                    <div class="ct_how_work_card">
                      <img
                        src="/assets/img/ri_find-replace-fill_orange.png"
                        className="ct_w_50_340"
                        alt=""
                      />
                      <div className="pt-3">
                        <h4 class="ct_fs_20 mb-3 ct_darksky_blue_text">
                          Live Strategy Workshop
                        </h4>
                        <p class="mb-0" style={{ maxWidth: "234px" }}>
                          {templateData?.section4?.body1 ?? ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="ct_how_work_card">
                      <img
                        src="/assets/img/fa6-solid_handshake_orange.png"
                        className="ct_w_50_340"
                        alt=""
                      />
                      <div className="pt-3">
                        <h4 class="ct_fs_20 mb-3 ct_darksky_blue_text">
                          Action-Ready Tools
                        </h4>
                        <p class="mb-0" style={{ maxWidth: "234px" }}>
                          {templateData?.section4?.body2 ?? ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="ct_how_work_card">
                      <img
                        src="/assets/img/uim_bag_orange.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div className="pt-3">
                        <h4 class="ct_fs_20 mb-3 ct_darksky_blue_text">
                          Real-Time Support
                        </h4>
                        <p class="mb-0" style={{ maxWidth: "234px" }}>
                          {templateData?.section4?.body3 ?? ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="ct_py_90 ct_light_sky_bg ">
          <div class="container">
            <div class="row">
              <div class="col-md-12 mb-4">
                <h2
                  class="ct_fs_32 mb-3 ct_fw_600 text-center "
                  style={{ color: "#FFB703" }}
                >
                  {templateData?.section5?.heading ?? ""}
                </h2>
                <p class="mb-0  text-center ct_fs_20">
                  {templateData?.section5?.body ?? ""}
                </p>
              </div>
            </div>
            <div class="row ct_pt_60">
              <div class="col-md-4 mb-4 mb-md-0">
                <div class="ct_glance_card text-center">
                  <figure class="mb-0">
                    <div class="ct_glance_icon mb-3">
                      <img
                        src="/assets/img/line-md_calendar.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                    </div>
                    <figcaption class="text-center">
                      <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                        Date & Time
                      </h4>
                      <p className="ct_fs_18 ct_line_h_30  mb-0">
                        <span className="ct_white_nowrap">Date: </span>
                        <label>{templateData?.section5?.date}</label>
                      </p>
                      <p className="ct_fs_18 ct_line_h_30  mb-0">
                        <span className="ct_white_nowrap">Time: </span>
                        <label>{templateData?.section5?.time}</label>
                      </p>
                      <p className="ct_fs_18 ct_line_h_30  mb-0">
                        <span className="ct_white_nowrap">Duration: </span>
                        <span>{templateData?.section5?.duration ?? ""}</span>
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div class="col-md-4 mb-4 mb-md-0">
                <div class="ct_glance_card text-center">
                  <figure class="mb-0">
                    <div class="ct_glance_icon mb-3">
                      <img
                        src="/assets/img/locationLogo.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                    </div>
                    <figcaption class="text-center">
                      <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                        Location
                      </h4>
                      <p className="ct_fs_18 ct_line_h_30   mb-0">
                        <span className="ct_white_nowrap">Platform: </span>
                        <span> {templateData?.section5?.platform ?? ""}</span>
                      </p>
                      <p className=" ct_fs_18 ct_line_h_30   mb-0">
                        <span className="ct_white_nowrap">Link: </span>{" "}
                        <span> {templateData?.section5?.link ?? ""} </span>
                      </p>
                      <p className=" ct_fs_18 ct_line_h_30   mb-0">
                        <span className="ct_white_nowrap">Replay Access: </span>
                        <span> {templateData?.section5?.access ?? ""}</span>
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div class="col-md-4 mb-4 mb-md-0">
                <div class="ct_glance_card text-center">
                  <figure class="mb-0">
                    <div class="ct_glance_icon mb-3">
                      <img
                        src="/assets/img/tabler_video-filled.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                    </div>
                    <figcaption class="text-center">
                      <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                        What You’ll Need
                      </h4>
                      <p class="mb-0 ct_fs_18 text-center mx-auto ct_line_h_30">
                        {templateData?.section5?.body1 ?? ""}
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="text-center ct_mt_40">
              <button
                class="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
                onClick={() => {
                  setIsSpotModal(true);
                  setId(templateData?.webinar_id);
                }}
              >
                Reserve Your Spot
              </button>
            </div>
          </div>
        </section>

        <section class=" ct_px_40 pt-0 ct_mt_100">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-xxl-7 col-xl-6 col-md-6 mb-4 mb-md-0">
                <div class="ct_about_cnt">
                  <h2 class="mb-4 ct_fs_32 mb-5 ">
                    Frequently asked questions
                  </h2>
                  <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                    <div class="accordion" id="faq_accordionExample">
                      {templateData?.section6?.faqs?.map((item, i) => (
                        <div className="d-flex align-items-center gap-2">
                          <div class="accordion-item ct_flex_1">
                            <h2 class="accordion-header" id="faq_one">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapsefaq_one${i}`}
                                aria-expanded="false"
                                aria-controls={`collapsefaq_one${i}`}
                              >
                                {item?.question != ""
                                  ? item?.question
                                  : "Enter Question"}
                              </button>
                            </h2>
                            <div
                              id={`collapsefaq_one${i}`}
                              class="accordion-collapse collapse"
                              aria-labelledby="faq_one"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  {item?.answer != ""
                                    ? item?.answer
                                    : "Enter Answer"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4  col-xl-6 col-md-6 mb-4 mb-md-0 ps-md-5">
                <label class="ct_about_img">
                  <img
                    src="/assets/img/faq_6789.png"
                    class="ct_img_h_617"
                    alt=""
                  />
                </label>
              </div>
            </div>
          </div>
        </section>

        <section
          class="ct_looking_for_work_bg ct_mt_100 ct_p_111_y_106"
          style={{ backgroundColor: "#FFB703" }}
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-4" style={{ maxWidth: "640px" }}>
                Ready to Join Us Live?
              </h4>
              <p class="mb-0 ct_fs_18" style={{ maxWidth: "619px" }}>
                Spaces are limited reserve your seat and walk away with clarity,
                strategy, and momentum{" "}
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
                View More
              </a>
            </div>
          </div>
        </section>

        <div style={{ height: "100px" }}></div>
        <div
          class="modal fade modal-lg"
          id="ct_waitlist_modal"
          tabindex="-1"
          aria-labelledby="ct_create_eventLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content ">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body p-0 pb-5">
                <h4 class=" text-center mb-1 ct_fs_18 ct_darksky_blue_text px-4">
                  You’re Almost In
                </h4>
                <p
                  class="mb-0 ct_grey_text px-4 ct_fs_14 text-center mx-auto"
                  style={{ maxWidth: "320px" }}
                >
                  Save your seat in just few clicks. Limited slots available
                </p>

                <form
                  action="javascript:void(0)"
                  class="mt-4 ct_modal_scroll ct_custom_scroll px-4"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-4">
                        <label for="" class="d-block mb-2 ct_fs_14">
                          Name
                        </label>
                        <input
                          type="text"
                          class="form-control ct_input ct_fs_14"
                          placeholder="Name"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group mb-4">
                        <label for="" class="d-block mb-2 ct_fs_14">
                          Email{" "}
                        </label>
                        <input
                          type="text"
                          class="form-control ct_input ct_fs_14"
                          placeholder="Email "
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group mb-4">
                        <label for="" class="d-block mb-2 ct_fs_14">
                          Timezone{" "}
                        </label>
                        <input
                          type="text"
                          class="form-control ct_input ct_fs_14"
                          placeholder="Timezone "
                        />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group mb-4">
                        <label for="" class="d-block mb-2 ct_fs_14">
                          Notes(Optional){" "}
                        </label>
                        <textarea
                          class="form-control ct_input ct_fs_14 h-auto"
                          rows="4"
                          placeholder="Let the coach know what you will like to focus on....."
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3 justify-content-center pt-2">
                    <button
                      class="ct_yellow_btn px-5 ct_h_44 ct_darksky_btn"
                      data-bs-toggle="modal"
                      data-bs-target="#ct_submit_modal"
                    >
                      Confirm My Spot
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {isSpotModal && (
          <ClaimYourSpot
            isOpen={isSpotModal}
            id={id}
            setClose={setIsSpotModal}
            isSuccessModal={isSuccessModal}
            setIsSuccessModal={setIsSuccessModal}
          />
        )}
      </>
    );
}

export default WebinarData
